var MDA_HANDOUT, MdaHandout, MdaHandoutView, MiniDSActions, MiniDSStore, MiniDSToolbar, QuestionsStatusesActions, ReactComponent, ReactToolbarView, View, alt, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

alt = require('alt');

MiniDSStore = require('stores/mini_ds_store');

MdaHandout = require('components/mda/handouts/mda_handout');

MDA_HANDOUT = require('lib/db_docs/doc_types').MDA_HANDOUT;

MiniDSActions = require('actions/mini_ds_actions');

MiniDSToolbar = require('components/mini_ds/toolbar');

mediator = require('mediator');

QuestionsStatusesActions = require('actions/questions_statuses_actions');

ReactComponent = require('base/lib/traits/react_component');

ReactToolbarView = require('views/react_toolbar_view');

View = require('base/views/view');

module.exports = MdaHandoutView = (function(_super) {
  __extends(MdaHandoutView, _super);

  function MdaHandoutView() {
    return MdaHandoutView.__super__.constructor.apply(this, arguments);
  }

  MdaHandoutView.prototype.container = '#page-container';

  MdaHandoutView.prototype.id = 'mda-handout';

  MdaHandoutView.prototype.autoRender = true;

  MdaHandoutView.prototype.initialize = function() {
    MdaHandoutView.__super__.initialize.apply(this, arguments);
    this.subview('toolbar', new ReactToolbarView({
      component: MiniDSToolbar,
      props: {
        currentDocumentId: this.options.handoutId,
        documentType: MDA_HANDOUT,
        projectId: mediator.project.id
      }
    }));
    return this.enable(ReactComponent);
  };

  MdaHandoutView.prototype.afterRender = function() {
    MdaHandoutView.__super__.afterRender.apply(this, arguments);
    QuestionsStatusesActions.fetch();
    return this.renderComponent(MdaHandout, MiniDSActions, this.options.handoutId, {
      props: {
        handoutId: this.options.handoutId
      },
      fetchAndListen: {
        dbId: mediator.project.id
      }
    });
  };

  MdaHandoutView.prototype.dispose = function() {
    if (this.disposed) {
      return;
    }
    this.unmountComponent();
    alt.recycle('DiscardChangesStore', 'DocumentSectionsV2Store', 'EDMSStore', 'MiniDSStore', 'OrganizationsStore', 'OverarchingQuestionsStore', 'QuestionGroupsStore', 'QuestionsListComponentStore', 'QuestionsStatusesStore', 'QuestionsStore');
    return MdaHandoutView.__super__.dispose.apply(this, arguments);
  };

  return MdaHandoutView;

})(View);
